// extracted by mini-css-extract-plugin
export default {"slider":"HeroSlider_slider__s8FDy","slide":"HeroSlider_slide__qKIWF","active":"HeroSlider_active__116S+","label":"HeroSlider_label__D2vrG","kicker":"HeroSlider_kicker__fMkl6"};